const en_sales_quotation = {
    "": "quotation",
    add: "create quotation",
    detail: "quotation detail",
    process: "quotation request process",

    message: {
        reject_title: "Are you sure you want to cancel the quotation?",
        reject_text: "Enter the reason for cancelling the quotation.",
    },

    error: {
        create: "Failed to create quotation.",
        edit: "Failed to update quotation.",

        reject: "Failed to cancel quotation.",
        approve: "Failed to confirm quotation.",
        done: "Failed to complete quotation.",
    },

    success: {
        create: "Quotation created successfully.",
        edit: "Quotation updated successfully.",

        reject: "Quotation cancelled successfully.",
        approve: "Quotation confirmed successfully.",
        done: "Quotation completed successfully.",
    },
}

export default en_sales_quotation;